import React from 'react';

export const IconLogo = ({ width = 693, height = 276, ...rest }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 693 276"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M157.43 5.41168C171.021 11.4215 187.459 27.662 193.432 40.9748C197.421 49.8689 198.501 56.0482 198.449 69.6957C198.364 92.0547 193.426 103.309 175.503 121.973L162.044 135.988H191.654C218.484 135.988 221.473 135.601 223.468 131.874C225.15 128.729 224.655 126.47 221.371 122.293C219.006 119.287 217.071 115.968 217.071 114.916C217.071 113.864 221.931 108.215 227.874 102.364C238.43 91.9656 238.774 91.8135 243.032 95.6693C254.982 106.483 259.794 131.272 252.671 145.334C243.306 163.831 235.903 167.18 201.322 168.567L173.618 169.678L189 186.522C197.46 195.786 206.062 203.367 208.119 203.367C213.598 203.367 217.071 198.981 217.071 192.065C217.071 185.281 219.982 184.673 239.589 187.361C250.804 188.898 251.619 190.843 247.405 206.017C242.858 222.39 225.231 235.874 208.377 235.874C195.462 235.874 184.238 228.863 165.587 209.142C155.8 198.792 147.24 190.326 146.569 190.326C144.017 190.326 145.33 237.259 147.953 239.882C151.659 243.588 158.447 243.11 163.201 238.809C167.078 235.298 167.795 235.651 178.465 246.32C189.437 257.292 189.583 257.603 185.69 261.902C179.537 268.703 164.466 275.093 154.58 275.093C143.141 275.093 134.98 271.972 127.22 264.63C116.016 254.03 114.096 247.833 112.831 218.186L111.656 190.622L93.3914 207.76C75.686 224.372 75.2274 225.05 78.4224 229.891C80.2351 232.636 84.2975 235.192 87.4491 235.57C93.072 236.246 93.1806 236.57 93.1806 252.55V268.84L82.8564 267.336C70.2609 265.504 63.4751 262.181 55.8265 254.095C48.3366 246.179 45.3632 238.15 45.3632 225.833C45.3632 211.501 50.534 202.696 68.5025 186.42C77.2944 178.459 84.4866 171.19 84.4866 170.267C84.4866 169.345 73.2734 168.591 59.5672 168.591C36.8908 168.591 34.4391 168.982 32.3265 172.929C30.4768 176.387 30.9919 178.602 34.8781 183.86L39.7534 190.452L28.5249 201.678C17.5204 212.683 17.2096 212.829 12.9104 208.936C0.488703 197.697 -3.8757 173.286 3.83595 158.18C13.3473 139.542 22.9477 135.988 63.7685 135.988C81.1415 135.988 95.3542 135.719 95.3542 135.39C95.3542 135.062 90.066 129.2 83.6019 122.364C67.4527 105.287 61.9189 93.2089 60.9648 72.956C59.3237 38.1145 78.6724 11.4845 112.588 1.89927C125.131 -1.64574 144.997 -0.0895032 157.43 5.41168ZM107.829 106.401C126.659 118.074 151.298 113.924 165.253 96.6159C179.365 79.1128 178.011 53.7856 162.113 37.8872C146.214 21.9888 120.887 20.6346 103.384 34.7471C85.8811 48.8597 81.834 73.8981 93.9997 92.8061L96.6017 95.4081L94.9531 105.275C94.8232 106.053 95.077 106.845 95.6344 107.403C96.1918 107.96 96.9842 108.214 97.7618 108.084L107.829 106.401ZM110.651 72.3023C113.772 72.3023 116.302 69.7722 116.302 66.6512C116.302 63.5301 113.772 61 110.651 61C107.53 61 105 63.5301 105 66.6512C105 69.7722 107.53 72.3023 110.651 72.3023ZM138.472 66.651C138.472 69.772 135.942 72.3021 132.821 72.3021C129.7 72.3021 127.17 69.772 127.17 66.651C127.17 63.5299 129.7 60.9998 132.821 60.9998C135.942 60.9998 138.472 63.5299 138.472 66.651ZM154.991 72.3021C158.112 72.3021 160.642 69.772 160.642 66.651C160.642 63.5299 158.112 60.9998 154.991 60.9998C151.87 60.9998 149.34 63.5299 149.34 66.651C149.34 69.772 151.87 72.3021 154.991 72.3021Z"
            fill="#820ad1"
        />
        <path
            d="M362.939 198.358C348.114 198.358 336.322 194.315 327.563 186.229C318.803 178.031 314.423 166.352 314.423 151.19V122.89C314.423 107.728 318.803 96.1049 327.563 88.019C336.322 79.8207 348.114 75.7216 362.939 75.7216C377.763 75.7216 389.555 79.8207 398.315 88.019C407.074 96.1049 411.454 107.728 411.454 122.89V151.19C411.454 166.352 407.074 178.031 398.315 186.229C389.555 194.315 377.763 198.358 362.939 198.358ZM362.939 178.48C371.249 178.48 377.707 176.066 382.311 171.237C386.916 166.408 389.218 159.95 389.218 151.864V122.216C389.218 114.13 386.916 107.672 382.311 102.843C377.707 98.0141 371.249 95.5995 362.939 95.5995C354.74 95.5995 348.283 98.0141 343.566 102.843C338.961 107.672 336.659 114.13 336.659 122.216V151.864C336.659 159.95 338.961 166.408 343.566 171.237C348.283 176.066 354.74 178.48 362.939 178.48ZM470.883 198.358C462.797 198.358 455.441 196.674 448.815 193.305C442.301 189.936 437.135 185.05 433.317 178.649C429.498 172.248 427.589 164.499 427.589 155.402V153.043C427.589 143.947 429.498 136.198 433.317 129.796C437.135 123.395 442.301 118.51 448.815 115.141C455.441 111.771 462.797 110.087 470.883 110.087C478.856 110.087 485.707 111.491 491.434 114.298C497.162 117.106 501.766 120.98 505.248 125.922C508.842 130.751 511.2 136.254 512.323 142.431L491.771 146.811C491.322 143.441 490.311 140.409 488.739 137.714C487.167 135.019 484.921 132.885 482.001 131.312C479.193 129.74 475.656 128.954 471.388 128.954C467.12 128.954 463.246 129.909 459.765 131.818C456.395 133.615 453.7 136.366 451.679 140.072C449.769 143.666 448.815 148.102 448.815 153.38V155.065C448.815 160.343 449.769 164.835 451.679 168.541C453.7 172.135 456.395 174.887 459.765 176.796C463.246 178.593 467.12 179.491 471.388 179.491C477.789 179.491 482.619 177.863 485.875 174.606C489.245 171.237 491.378 166.857 492.277 161.466L512.829 166.352C511.369 172.304 508.842 177.75 505.248 182.692C501.766 187.521 497.162 191.339 491.434 194.147C485.707 196.955 478.856 198.358 470.883 198.358ZM559.548 196C554.045 196 549.553 194.315 546.071 190.946C542.702 187.465 541.017 182.86 541.017 177.133V129.965H520.129V112.445H541.017V86.5029H562.243V112.445H585.153V129.965H562.243V173.427C562.243 176.796 563.815 178.48 566.96 178.48H583.132V196H559.548ZM641.161 198.358C632.851 198.358 625.382 196.674 618.756 193.305C612.13 189.936 606.908 185.05 603.09 178.649C599.272 172.248 597.362 164.555 597.362 155.57V152.875C597.362 143.891 599.272 136.198 603.09 129.796C606.908 123.395 612.13 118.51 618.756 115.141C625.382 111.771 632.851 110.087 641.161 110.087C649.472 110.087 656.94 111.771 663.566 115.141C670.192 118.51 675.414 123.395 679.233 129.796C683.051 136.198 684.96 143.891 684.96 152.875V155.57C684.96 164.555 683.051 172.248 679.233 178.649C675.414 185.05 670.192 189.936 663.566 193.305C656.94 196.674 649.472 198.358 641.161 198.358ZM641.161 179.491C647.675 179.491 653.066 177.414 657.333 173.258C661.601 168.991 663.735 162.926 663.735 155.065V153.38C663.735 145.519 661.601 139.511 657.333 135.355C653.178 131.088 647.787 128.954 641.161 128.954C634.648 128.954 629.257 131.088 624.989 135.355C620.722 139.511 618.588 145.519 618.588 153.38V155.065C618.588 162.926 620.722 168.991 624.989 173.258C629.257 177.414 634.648 179.491 641.161 179.491Z"
            fill="#820ad1"
        />
    </svg>
);

export const IconLogoPolvo = ({ width = 693, height = 276, ...rest }) => (
    <svg
        width="256"
        height="276"
        viewBox="0 0 256 276"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M157.43 5.41168C171.021 11.4215 187.459 27.662 193.432 40.9748C197.421 49.8689 198.501 56.0482 198.449 69.6957C198.364 92.0547 193.426 103.309 175.503 121.973L162.044 135.988H191.654C218.484 135.988 221.473 135.601 223.468 131.874C225.15 128.729 224.655 126.47 221.371 122.293C219.006 119.287 217.071 115.968 217.071 114.916C217.071 113.864 221.931 108.215 227.874 102.364C238.43 91.9656 238.774 91.8135 243.032 95.6693C254.982 106.483 259.794 131.272 252.671 145.334C243.306 163.831 235.903 167.18 201.322 168.567L173.618 169.678L189 186.522C197.46 195.786 206.062 203.367 208.119 203.367C213.598 203.367 217.071 198.981 217.071 192.065C217.071 185.281 219.982 184.673 239.589 187.361C250.804 188.898 251.619 190.843 247.405 206.017C242.858 222.39 225.231 235.874 208.377 235.874C195.462 235.874 184.238 228.863 165.587 209.142C155.8 198.792 147.24 190.326 146.569 190.326C144.017 190.326 145.33 237.259 147.953 239.882C151.659 243.588 158.447 243.11 163.201 238.809C167.078 235.298 167.795 235.651 178.465 246.32C189.437 257.292 189.583 257.603 185.69 261.902C179.537 268.703 164.466 275.093 154.58 275.093C143.141 275.093 134.98 271.972 127.22 264.63C116.016 254.03 114.096 247.833 112.831 218.186L111.656 190.622L93.3914 207.76C75.686 224.372 75.2274 225.05 78.4224 229.891C80.2351 232.636 84.2975 235.192 87.4491 235.57C93.072 236.246 93.1806 236.57 93.1806 252.55V268.84L82.8564 267.336C70.2609 265.504 63.4751 262.181 55.8265 254.095C48.3366 246.179 45.3632 238.15 45.3632 225.833C45.3632 211.501 50.534 202.696 68.5025 186.42C77.2944 178.459 84.4866 171.19 84.4866 170.267C84.4866 169.345 73.2734 168.591 59.5672 168.591C36.8908 168.591 34.4391 168.982 32.3265 172.929C30.4768 176.387 30.9919 178.602 34.8781 183.86L39.7534 190.452L28.5249 201.678C17.5204 212.683 17.2096 212.829 12.9104 208.936C0.488703 197.697 -3.8757 173.286 3.83595 158.18C13.3473 139.542 22.9477 135.988 63.7685 135.988C81.1415 135.988 95.3542 135.719 95.3542 135.39C95.3542 135.062 90.066 129.2 83.6019 122.364C67.4527 105.287 61.9189 93.2089 60.9648 72.956C59.3237 38.1145 78.6724 11.4845 112.588 1.89927C125.131 -1.64574 144.997 -0.0895014 157.43 5.41168ZM107.829 106.401C126.659 118.074 151.298 113.924 165.253 96.6159C179.365 79.1128 178.011 53.7856 162.113 37.8872C146.214 21.9888 120.887 20.6346 103.384 34.7471C85.8811 48.8597 81.834 73.8981 93.9997 92.8061L96.6017 95.4081L94.9531 105.275C94.8232 106.053 95.077 106.845 95.6344 107.403C96.1918 107.96 96.9842 108.214 97.7618 108.084L107.829 106.401ZM110.651 72.3023C113.772 72.3023 116.302 69.7722 116.302 66.6512C116.302 63.5301 113.772 61 110.651 61C107.53 61 105 63.5301 105 66.6512C105 69.7722 107.53 72.3023 110.651 72.3023ZM138.472 66.651C138.472 69.772 135.942 72.3021 132.821 72.3021C129.7 72.3021 127.17 69.772 127.17 66.651C127.17 63.5299 129.7 60.9998 132.821 60.9998C135.942 60.9998 138.472 63.5299 138.472 66.651ZM154.991 72.3021C158.112 72.3021 160.642 69.772 160.642 66.651C160.642 63.5299 158.112 60.9998 154.991 60.9998C151.87 60.9998 149.34 63.5299 149.34 66.651C149.34 69.772 151.87 72.3021 154.991 72.3021Z"
            fill="#820AD1"
        />
    </svg>
);

export const IconDashboard = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M24 21h2v5h-2zm-4-5h2v10h-2zm-9 10a5.006 5.006 0 0 1-5-5h2a3 3 0 1 0 3-3v-2a5 5 0 0 1 0 10z"
        />
        <path
            fill="currentColor"
            d="M28 2H4a2.002 2.002 0 0 0-2 2v24a2.002 2.002 0 0 0 2 2h24a2.003 2.003 0 0 0 2-2V4a2.002 2.002 0 0 0-2-2Zm0 9H14V4h14ZM12 4v7H4V4ZM4 28V13h24l.002 15Z"
        />
    </svg>
);
export const IconSend = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M27.71 4.29a1 1 0 0 0-1.05-.23l-22 8a1 1 0 0 0 0 1.87l9.6 3.84l3.84 9.6a1 1 0 0 0 .9.63a1 1 0 0 0 .92-.66l8-22a1 1 0 0 0-.21-1.05ZM19 24.2l-2.79-7L21 12.41L19.59 11l-4.83 4.83L7.8 13l17.53-6.33Z"
        />
    </svg>
);
export const IconCampgain = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="m29.509 17.689l-6-3.55a.997.997 0 0 0-1.018.001l-6 3.55a.998.998 0 0 0-.491.86v6.9c0 .354.187.681.491.86l6 3.55a.989.989 0 0 0 1.018 0l6-3.55a.998.998 0 0 0 .491-.86v-6.9a1 1 0 0 0-.491-.861zM28 24.88l-5 2.958l-5-2.958v-5.76l5-2.958l5 2.958v5.76z"
        />
        <circle cx="6" cy="6" r="1" fill="currentColor" />
        <circle cx="9" cy="6" r="1" fill="currentColor" />
        <path
            fill="currentColor"
            d="M28 2H4c-1.103 0-2 .897-2 2v20c0 1.103.897 2 2 2h9v-2H4V10h24v4h2V4c0-1.103-.897-2-2-2zM4 8V4h24v4H4z"
        />
    </svg>
);
export const IconListContacts = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M21 22h-2v-2a1.001 1.001 0 0 0-1-1h-4a1.001 1.001 0 0 0-1 1v2h-2v-2a3.003 3.003 0 0 1 3-3h4a3.003 3.003 0 0 1 3 3zm-5-6a3.5 3.5 0 1 1 3.5-3.5A3.504 3.504 0 0 1 16 16zm0-5a1.5 1.5 0 1 0 1.5 1.5A1.502 1.502 0 0 0 16 11z"
        />
        <path
            fill="currentColor"
            d="M30.414 17.414a2 2 0 0 0 0-2.828l-5.787-5.787l2.9-2.862a2.002 2.002 0 1 0-1.44-1.388l-2.874 2.836l-5.799-5.8a2 2 0 0 0-2.828 0L8.799 7.374L5.937 4.472A2.002 2.002 0 1 0 4.55 5.914l2.835 2.873l-5.8 5.799a2 2 0 0 0 0 2.828l5.8 5.799l-2.835 2.873a1.998 1.998 0 1 0 1.387 1.442l2.862-2.9l5.787 5.786a2 2 0 0 0 2.828 0l5.8-5.799l2.872 2.836a1.998 1.998 0 1 0 1.442-1.387l-2.9-2.863ZM16 29L3 16L16 3l13 13Z"
        />
    </svg>
);
export const IconBlocklist = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M30 24a6 6 0 1 0-6 6a6.007 6.007 0 0 0 6-6zm-2 0a3.952 3.952 0 0 1-.567 2.019l-5.452-5.452A3.953 3.953 0 0 1 24 20a4.005 4.005 0 0 1 4 4zm-8 0a3.952 3.952 0 0 1 .567-2.019l5.452 5.452A3.953 3.953 0 0 1 24 28a4.005 4.005 0 0 1-4-4zM8 16h10v2H8zm0-6h12v2H8z"
        />
        <path
            fill="currentColor"
            d="m14 27.733l-5.234-2.79A8.986 8.986 0 0 1 4 17V4h20v11h2V4a2.002 2.002 0 0 0-2-2H4a2.002 2.002 0 0 0-2 2v13a10.981 10.981 0 0 0 5.824 9.707L14 30Z"
        />
    </svg>
);
export const IconLandingPage = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="m29.707 19.293l-3-3a1 1 0 0 0-1.414 0L16 25.586V30h4.414l9.293-9.293a1 1 0 0 0 0-1.414ZM19.586 28H18v-1.586l5-5L24.586 23ZM26 21.586L24.414 20L26 18.414L27.586 20ZM18 18v-4h2v4zm-4 0v-6h2v6zm-4 0V8h2v10z"
        />
        <path
            fill="currentColor"
            d="M12 30H6a2.002 2.002 0 0 1-2-2V4a2.002 2.002 0 0 1 2-2h16a2.002 2.002 0 0 1 2 2v10h-2V4H6v24h6Z"
        />
    </svg>
);
export const IconAnalytics = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M16 2a1 1 0 0 0-1 1v7.09a5.962 5.962 0 0 0-2.46 1.043L7.838 6.431a1.455 1.455 0 0 0-2.087.024a14.05 14.05 0 0 0 4.054 22.142a10.848 10.848 0 0 0 1.899.768a14.098 14.098 0 0 0 13.844-3.132a1.434 1.434 0 0 0 .028-2.064l-4.699-4.699A5.963 5.963 0 0 0 21.91 17H29a1 1 0 0 0 1-1A14.016 14.016 0 0 0 16 2Zm0 10a4 4 0 1 1-4 4a4.005 4.005 0 0 1 4-4ZM6.83 8.251l4.296 4.296a5.91 5.91 0 0 0-.011 6.924l-4.277 4.277A12.017 12.017 0 0 1 6.83 8.251Zm1.423 16.91l4.276-4.276A5.959 5.959 0 0 0 15 21.91v6.042a11.878 11.878 0 0 1-6.747-2.79ZM17 27.956V21.91a5.963 5.963 0 0 0 2.46-1.027l4.283 4.282A11.89 11.89 0 0 1 17 27.956ZM21.91 15A6.006 6.006 0 0 0 17 10.09V4.041A12.02 12.02 0 0 1 27.959 15Z"
        />
    </svg>
);
export const IconConfig = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M27 16.76v-1.53l1.92-1.68A2 2 0 0 0 29.3 11l-2.36-4a2 2 0 0 0-1.73-1a2 2 0 0 0-.64.1l-2.43.82a11.35 11.35 0 0 0-1.31-.75l-.51-2.52a2 2 0 0 0-2-1.61h-4.68a2 2 0 0 0-2 1.61l-.51 2.52a11.48 11.48 0 0 0-1.32.75l-2.38-.86A2 2 0 0 0 6.79 6a2 2 0 0 0-1.73 1L2.7 11a2 2 0 0 0 .41 2.51L5 15.24v1.53l-1.89 1.68A2 2 0 0 0 2.7 21l2.36 4a2 2 0 0 0 1.73 1a2 2 0 0 0 .64-.1l2.43-.82a11.35 11.35 0 0 0 1.31.75l.51 2.52a2 2 0 0 0 2 1.61h4.72a2 2 0 0 0 2-1.61l.51-2.52a11.48 11.48 0 0 0 1.32-.75l2.42.82a2 2 0 0 0 .64.1a2 2 0 0 0 1.73-1l2.28-4a2 2 0 0 0-.41-2.51ZM25.21 24l-3.43-1.16a8.86 8.86 0 0 1-2.71 1.57L18.36 28h-4.72l-.71-3.55a9.36 9.36 0 0 1-2.7-1.57L6.79 24l-2.36-4l2.72-2.4a8.9 8.9 0 0 1 0-3.13L4.43 12l2.36-4l3.43 1.16a8.86 8.86 0 0 1 2.71-1.57L13.64 4h4.72l.71 3.55a9.36 9.36 0 0 1 2.7 1.57L25.21 8l2.36 4l-2.72 2.4a8.9 8.9 0 0 1 0 3.13L27.57 20Z"
        />
        <path
            fill="currentColor"
            d="M16 22a6 6 0 1 1 6-6a5.94 5.94 0 0 1-6 6Zm0-10a3.91 3.91 0 0 0-4 4a3.91 3.91 0 0 0 4 4a3.91 3.91 0 0 0 4-4a3.91 3.91 0 0 0-4-4Z"
        />
    </svg>
);
export const IconPower = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="m22.5 5.74l-1 1.73a11 11 0 1 1-11 0l-1-1.73a13 13 0 1 0 13 0Z"
        />
        <path fill="currentColor" d="M15 2h2v14h-2z" />
    </svg>
);
export const IconBell = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M28.707 19.293L26 16.586V13a10.014 10.014 0 0 0-9-9.95V1h-2v2.05A10.014 10.014 0 0 0 6 13v3.586l-2.707 2.707A1 1 0 0 0 3 20v3a1 1 0 0 0 1 1h7v.777a5.152 5.152 0 0 0 4.5 5.199A5.006 5.006 0 0 0 21 25v-1h7a1 1 0 0 0 1-1v-3a1 1 0 0 0-.293-.707ZM19 25a3 3 0 0 1-6 0v-1h6Zm8-3H5v-1.586l2.707-2.707A1 1 0 0 0 8 17v-4a8 8 0 0 1 16 0v4a1 1 0 0 0 .293.707L27 20.414Z"
        />
    </svg>
);
export const IconDate = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M26 4h-4V2h-2v2h-8V2h-2v2H6c-1.1 0-2 .9-2 2v20c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 22H6V12h20v14zm0-16H6V6h4v2h2V6h8v2h2V6h4v4z"
        />
    </svg>
);

export const IconLoadingPointer = ({ ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <circle cx="18" cy="12" r="0" fill="currentColor">
            <animate
                attributeName="r"
                begin=".67"
                calcMode="spline"
                dur="1.5s"
                keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
                repeatCount="indefinite"
                values="0;2;0;0"
            />
        </circle>
        <circle cx="12" cy="12" r="0" fill="currentColor">
            <animate
                attributeName="r"
                begin=".33"
                calcMode="spline"
                dur="1.5s"
                keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
                repeatCount="indefinite"
                values="0;2;0;0"
            />
        </circle>
        <circle cx="6" cy="12" r="0" fill="currentColor">
            <animate
                attributeName="r"
                begin="0"
                calcMode="spline"
                dur="1.5s"
                keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
                repeatCount="indefinite"
                values="0;2;0;0"
            />
        </circle>
    </svg>
);

export function IconWhatsapp({ color = '#000', size = '20px' }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            width={size}
            height={size}
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 16 16"
        >
            <path
                fill="currentColor"
                d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144l-2.494.654l.666-2.433l-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931a6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646c-.182-.065-.315-.099-.445.099c-.133.197-.513.646-.627.775c-.114.133-.232.148-.43.05c-.197-.1-.836-.308-1.592-.985c-.59-.525-.985-1.175-1.103-1.372c-.114-.198-.011-.304.088-.403c.087-.088.197-.232.296-.346c.1-.114.133-.198.198-.33c.065-.134.034-.248-.015-.347c-.05-.099-.445-1.076-.612-1.47c-.16-.389-.323-.335-.445-.34c-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654c0 .977.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992c.47.205.84.326 1.129.418c.475.152.904.129 1.246.08c.38-.058 1.171-.48 1.338-.943c.164-.464.164-.86.114-.943c-.049-.084-.182-.133-.38-.232z"
            />
        </svg>
    );
}

export function IconLoading({ color = '#000', size = '20px' }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            width={size}
            height={size}
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8A8 8 0 0 1 12 20Z"
                opacity=".5"
            />
            <path
                fill="currentColor"
                d="M20 12h2A10 10 0 0 0 12 2V4A8 8 0 0 1 20 12Z"
            >
                <animateTransform
                    attributeName="transform"
                    dur="1s"
                    from="0 12 12"
                    repeatCount="indefinite"
                    to="360 12 12"
                    type="rotate"
                />
            </path>
        </svg>
    );
}

export function IconClose({ color = '#000', width = '17px' }) {
    return (
        <svg
            width={width}
            height={width}
            viewBox="0 0 635 652"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M369.8 326L632.3 13.1C636.7 7.90001 633 0 626.2 0H546.4C541.7 0 537.2 2.1 534.1 5.7L317.6 263.8L101.1 5.7C98.1002 2.1 93.6002 0 88.8002 0H9.0002C2.2002 0 -1.4998 7.90001 2.9002 13.1L265.4 326L2.9002 638.9C1.91456 640.059 1.28223 641.477 1.07827 642.984C0.874304 644.492 1.10727 646.027 1.74953 647.406C2.39179 648.785 3.41637 649.951 4.7016 650.766C5.98684 651.58 7.47874 652.008 9.0002 652H88.8002C93.5002 652 98.0002 649.9 101.1 646.3L317.6 388.2L534.1 646.3C537.1 649.9 541.6 652 546.4 652H626.2C633 652 636.7 644.1 632.3 638.9L369.8 326Z"
                fill={color}
            />
        </svg>
    );
}

export const IconEyeClose = ({ color = '#000', size = '20px' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <rect
                x="0"
                y="0"
                width="24"
                height="24"
                fill="none"
                stroke="none"
            />
            <path
                fill="currentColor"
                d="M2 5.27L3.28 4L20 20.72L18.73 22l-3.08-3.08c-1.15.38-2.37.58-3.65.58c-5 0-9.27-3.11-11-7.5c.69-1.76 1.79-3.31 3.19-4.54L2 5.27M12 9a3 3 0 0 1 3 3a3 3 0 0 1-.17 1L11 9.17A3 3 0 0 1 12 9m0-4.5c5 0 9.27 3.11 11 7.5a11.79 11.79 0 0 1-4 5.19l-1.42-1.43A9.862 9.862 0 0 0 20.82 12A9.821 9.821 0 0 0 12 6.5c-1.09 0-2.16.18-3.16.5L7.3 5.47c1.44-.62 3.03-.97 4.7-.97M3.18 12A9.821 9.821 0 0 0 12 17.5c.69 0 1.37-.07 2-.21L11.72 15A3.064 3.064 0 0 1 9 12.28L5.6 8.87c-.99.85-1.82 1.91-2.42 3.13Z"
            />
        </svg>
    );
};

export const IconEye = ({ color = '#000', size = '20px' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <rect
                x="0"
                y="0"
                width="24"
                height="24"
                fill="none"
                stroke="none"
            />
            <path
                fill="currentColor"
                d="M12 9a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0-4.5c5 0 9.27 3.11 11 7.5c-1.73 4.39-6 7.5-11 7.5S2.73 16.39 1 12c1.73-4.39 6-7.5 11-7.5M3.18 12a9.821 9.821 0 0 0 17.64 0a9.821 9.821 0 0 0-17.64 0Z"
            />
        </svg>
    );
};

export const IconEdit = ({ color = '#000', size = '20px' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
        >
            <rect
                x="0"
                y="0"
                width="32"
                height="32"
                fill="none"
                stroke="none"
            />
            <path
                fill="currentColor"
                d="M2 26h28v2H2zM25.4 9c.8-.8.8-2 0-2.8l-3.6-3.6c-.8-.8-2-.8-2.8 0l-15 15V24h6.4l15-15zm-5-5L24 7.6l-3 3L17.4 7l3-3zM6 22v-3.6l10-10l3.6 3.6l-10 10H6z"
            />
        </svg>
    );
};

export const IconRemove = ({ color = '#000', size = '20px' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
        >
            <rect
                x="0"
                y="0"
                width="32"
                height="32"
                fill="none"
                stroke="none"
            />
            <path fill="currentColor" d="M12 12h2v12h-2zm6 0h2v12h-2z" />
            <path
                fill="currentColor"
                d="M4 6v2h2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8h2V6zm4 22V8h16v20zm4-26h8v2h-8z"
            />
        </svg>
    );
};

export const IconCloseLine = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M24 9.4L22.6 8L16 14.6L9.4 8L8 9.4l6.6 6.6L8 22.6L9.4 24l6.6-6.6l6.6 6.6l1.4-1.4l-6.6-6.6L24 9.4z"
        />
    </svg>
);
export const IconExpand = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M10 21v-2H6.41l4.5-4.5l-1.41-1.41l-4.5 4.5V14H3v7h7m4.5-10.09l4.5-4.5V10h2V3h-7v2h3.59l-4.5 4.5l1.41 1.41Z"
        />
    </svg>
);

export const IconUploadMac = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
        <g
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-width="1.5"
        >
            <path d="M14 21H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v9" />
            <path
                stroke-linejoin="round"
                d="M2 7h20M5 5.01l.01-.011M8 5.01l.01-.011M11 5.01l.01-.011M19.5 22v-6m0 0L17 18.5m2.5-2.5l2.5 2.5"
            />
        </g>
    </svg>
);

export const IconArrowLeftDown = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
        <g
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-width="1.5"
        >
            <path stroke-linejoin="round" d="m7 14.5l5 5l5-5" />
            <path d="M12 19.5v-10c0-1.667 1-5 5-5" opacity=".5" />
        </g>
    </svg>
);

export const IconArrow = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="m14 26l1.41-1.41L7.83 17H28v-2H7.83l7.58-7.59L14 6L4 16l10 10z"
        />
    </svg>
);

export const IconFilters = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M18 28h-4a2 2 0 0 1-2-2v-7.59L4.59 11A2 2 0 0 1 4 9.59V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v3.59a2 2 0 0 1-.59 1.41L20 18.41V26a2 2 0 0 1-2 2ZM6 6v3.59l8 8V26h4v-8.41l8-8V6Z"
        />
    </svg>
);

export const IconDownload = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M23.5 22H23v-2h.5a4.5 4.5 0 0 0 .36-9H23l-.1-.82a7 7 0 0 0-13.88 0L9 11h-.86a4.5 4.5 0 0 0 .36 9H9v2h-.5A6.5 6.5 0 0 1 7.2 9.14a9 9 0 0 1 17.6 0A6.5 6.5 0 0 1 23.5 22Z"
        />
        <path
            fill="currentColor"
            d="M17 26.17V14h-2v12.17l-2.59-2.58L11 25l5 5l5-5l-1.41-1.41L17 26.17z"
        />
    </svg>
);

export const IconUsers = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="256"
        height="256"
        viewBox="0 0 256 256"
    >
        <rect x="0" y="0" width="256" height="256" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M29.6 123.2a4 4 0 0 0 5.6-.8a56 56 0 0 1 89.6 0a3.93 3.93 0 0 0 6.38 0a56 56 0 0 1 89.6 0a4 4 0 1 0 6.4-4.8a63.55 63.55 0 0 0-32.5-22.85a36 36 0 1 0-37.4 0a63.39 63.39 0 0 0-29.3 19a63.34 63.34 0 0 0-29.3-19a36 36 0 1 0-37.4 0A63.61 63.61 0 0 0 28.8 117.6a4 4 0 0 0 .8 5.6ZM148 64a28 28 0 1 1 28 28a28 28 0 0 1-28-28Zm-96 0a28 28 0 1 1 28 28a28 28 0 0 1-28-28Zm142.7 134.75a36 36 0 1 0-37.4 0A63.39 63.39 0 0 0 128 217.7a63.34 63.34 0 0 0-29.3-18.95a36 36 0 1 0-37.4 0a63.61 63.61 0 0 0-32.5 22.85a4 4 0 0 0 6.4 4.8a56 56 0 0 1 89.6 0a3.93 3.93 0 0 0 6.38 0a56 56 0 0 1 89.6 0a4 4 0 0 0 6.4-4.8a63.55 63.55 0 0 0-32.48-22.85ZM52 168a28 28 0 1 1 28 28a28 28 0 0 1-28-28Zm96 0a28 28 0 1 1 28 28a28 28 0 0 1-28-28Z"
        />
    </svg>
);

export const IconSmile = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
        <g fill="none">
            <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="1.5"
                d="M9 16c.85.63 1.885 1 3 1s2.15-.37 3-1"
            />
            <ellipse cx="15" cy="10.5" fill="currentColor" rx="1" ry="1.5" />
            <ellipse cx="9" cy="10.5" fill="currentColor" rx="1" ry="1.5" />
            <path
                stroke="currentColor"
                stroke-width="1.5"
                d="M2 12c0-4.714 0-7.071 1.464-8.536C4.93 2 7.286 2 12 2c4.714 0 7.071 0 8.535 1.464C22 4.93 22 7.286 22 12c0 4.714 0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12Z"
                opacity=".5"
            />
        </g>
    </svg>
);

export const IconWifi = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="m6.35 15.35l-2.1-2.15q1.475-1.475 3.463-2.337T12 10q2.3 0 4.288.875t3.462 2.375l-2.1 2.1q-1.1-1.1-2.55-1.725T12 13q-1.65 0-3.1.625T6.35 15.35ZM2.1 11.1L0 9q2.3-2.35 5.375-3.675T12 4q3.55 0 6.625 1.325T24 9l-2.1 2.1q-1.925-1.925-4.463-3.013T12 7Q9.1 7 6.562 8.088T2.1 11.1ZM12 21l3.525-3.55q-.675-.675-1.575-1.063T12 16q-1.05 0-1.95.388T8.475 17.45L12 21Z"
        />
    </svg>
);
export const IconBatery = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="256"
        height="256"
        viewBox="0 0 256 256"
    >
        <rect x="0" y="0" width="256" height="256" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M200 58H32a22 22 0 0 0-22 22v96a22 22 0 0 0 22 22h168a22 22 0 0 0 22-22V80a22 22 0 0 0-22-22Zm10 118a10 10 0 0 1-10 10H32a10 10 0 0 1-10-10V80a10 10 0 0 1 10-10h168a10 10 0 0 1 10 10Zm44-80v64a6 6 0 0 1-12 0V96a6 6 0 0 1 12 0Zm-116.9 28.85a6 6 0 0 1 .27 5.83l-16 32a6 6 0 1 1-10.74-5.36L122.29 134H100a6 6 0 0 1-5.37-8.68l16-32a6 6 0 0 1 10.74 5.36L109.71 122H132a6 6 0 0 1 5.1 2.85Z"
        />
    </svg>
);

export const IconHours = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path fill="currentColor" d="M15 11h2v9h-2zm-2-9h6v2h-6z" />
        <path
            fill="currentColor"
            d="m28 9l-1.42-1.41l-2.25 2.25a10.94 10.94 0 1 0 1.18 1.65ZM16 26a9 9 0 1 1 9-9a9 9 0 0 1-9 9Z"
        />
    </svg>
);

export const IconCanal = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M27.71 4.29a1 1 0 0 0-1.05-.23l-22 8a1 1 0 0 0 0 1.87l9.6 3.84l3.84 9.6a1 1 0 0 0 .9.63a1 1 0 0 0 .92-.66l8-22a1 1 0 0 0-.21-1.05ZM19 24.2l-2.79-7L21 12.41L19.59 11l-4.83 4.83L7.8 13l17.53-6.33Z"
        />
    </svg>
);

export const IconQueue = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M22 20h8v2h-8zm0 4h8v2h-8zm0 4h8v2h-8zm-4-4h2v2h-2zm0-4h2v2h-2zm0 8h2v2h-2zM6.815 8.293a12.078 12.078 0 0 1 3.192-2.673l-1-1.73a14.085 14.085 0 0 0-3.723 3.118zm18.37 0l1.53-1.285a14.085 14.085 0 0 0-3.723-3.118l-.999 1.73a12.078 12.078 0 0 1 3.192 2.673zM4.737 11.9l-1.878-.683A13.902 13.902 0 0 0 2 16h2a11.917 11.917 0 0 1 .737-4.1zm2.078 11.807A11.998 11.998 0 0 1 4.737 20.1l-1.878.683a13.99 13.99 0 0 0 2.425 4.21zM27.263 11.9A11.917 11.917 0 0 1 28 16h2a13.897 13.897 0 0 0-.86-4.783zM13.918 27.807a11.89 11.89 0 0 1-3.911-1.427l-1 1.73a13.867 13.867 0 0 0 4.564 1.664zm0-23.614a11.301 11.301 0 0 1 4.164 0l.347-1.967a13.187 13.187 0 0 0-4.858 0z"
        />
    </svg>
);

export const IconEnviado = ({ color = '#000', size = '20px' }) => (
    <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.6375 1.42133L12.04 0.925334C11.9448 0.84686 11.8244 0.811659 11.7051 0.82739C11.5857 0.843122 11.4769 0.908513 11.4025 1.00933L4.70751 10.172C4.67301 10.2212 4.62897 10.2618 4.5784 10.2912C4.52782 10.3205 4.47191 10.3379 4.41447 10.342C4.35703 10.3462 4.29942 10.3371 4.24558 10.3154C4.19174 10.2936 4.14294 10.2597 4.10251 10.216L1.36376 7.35867C1.27711 7.26926 1.16088 7.21995 1.04034 7.22145C0.919795 7.22295 0.804677 7.27513 0.720007 7.36667L0.191257 7.944C0.107211 8.03603 0.0608047 8.15985 0.0622106 8.28832C0.0636165 8.41679 0.11272 8.53942 0.198757 8.62933L4.27126 12.876C4.45001 13.0627 4.72251 13.0427 4.87626 12.832L12.7163 2.10133C12.7898 1.99981 12.8228 1.8714 12.8081 1.74405C12.7933 1.6167 12.732 1.50071 12.6375 1.42133Z"
            fill="black"
        ></path>
    </svg>
);
export const IconRecebido = ({ color = '#000', size = '20px' }) => (
    <svg
        width="18"
        height="13"
        viewBox="0 0 18 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.7625 1.145L17.165 0.680001C17.0698 0.606432 16.9494 0.573431 16.83 0.588179C16.7106 0.602928 16.6019 0.664232 16.5275 0.758751L9.83249 9.34875C9.798 9.39485 9.75396 9.43295 9.70338 9.46046C9.65281 9.48797 9.59689 9.50424 9.53945 9.50816C9.48201 9.51207 9.42441 9.50354 9.37057 9.48315C9.31673 9.46276 9.26792 9.43099 9.22749 9.39L8.77999 8.98375C8.73975 8.9425 8.69104 8.91047 8.63723 8.88985C8.58342 8.86924 8.52577 8.86053 8.46827 8.86433C8.41077 8.86814 8.35478 8.88436 8.30415 8.91188C8.25352 8.9394 8.20945 8.97757 8.17499 9.02375L7.70249 9.6275C7.62839 9.72718 7.59223 9.84999 7.60047 9.97391C7.60872 10.0978 7.66084 10.2148 7.74749 10.3038L9.39749 11.8863C9.57624 12.0613 9.84874 12.0425 10.0025 11.845L17.8425 1.785C17.9164 1.68938 17.9494 1.56841 17.9345 1.44851C17.9195 1.3286 17.8576 1.21949 17.7625 1.145ZM12.6375 1.145L12.04 0.680001C11.9448 0.606432 11.8244 0.573431 11.705 0.588179C11.5856 0.602928 11.4769 0.664232 11.4025 0.758751L4.70749 9.34875C4.673 9.39485 4.62896 9.43295 4.57838 9.46046C4.52781 9.48797 4.47189 9.50424 4.41445 9.50816C4.35701 9.51207 4.29941 9.50354 4.24557 9.48315C4.19173 9.46276 4.14292 9.43099 4.10249 9.39L1.36374 6.71125C1.2771 6.62743 1.16087 6.5812 1.04032 6.58261C0.91978 6.58401 0.804662 6.63294 0.719992 6.71875L0.191242 7.26C0.107196 7.34628 0.0607894 7.46236 0.0621953 7.5828C0.0636012 7.70324 0.112705 7.81821 0.198742 7.9025L4.27124 11.8838C4.44999 12.0588 4.72249 12.04 4.87624 11.8425L12.7162 1.7825C12.7898 1.68732 12.8228 1.56694 12.8081 1.44754C12.7933 1.32815 12.732 1.21942 12.6375 1.145Z"
            fill={color}
        ></path>
    </svg>
);
export const IconConfirmado = ({ color = '#000', size = '20px' }) => (
    <svg
        width="18"
        height="12"
        viewBox="0 0 18 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.7003 0.560266L17.1028 0.0952655C17.0076 0.0216963 16.8873 -0.0113049 16.7679 0.00344339C16.6485 0.0181917 16.5397 0.079496 16.4653 0.174015L9.77033 8.76402C9.73583 8.81011 9.69179 8.84821 9.64122 8.87572C9.59064 8.90323 9.53473 8.9195 9.47729 8.92342C9.41985 8.92734 9.36224 8.91881 9.3084 8.89842C9.25456 8.87802 9.20576 8.84625 9.16533 8.80527L8.71783 8.39902C8.67758 8.35777 8.62888 8.32573 8.57506 8.30512C8.52125 8.2845 8.46361 8.2758 8.40611 8.2796C8.34861 8.2834 8.29261 8.29962 8.24198 8.32714C8.19135 8.35466 8.14729 8.39283 8.11283 8.43902L7.64033 9.04277C7.56623 9.14244 7.53006 9.26525 7.53831 9.38918C7.54656 9.5131 7.59868 9.63004 7.68533 9.71902L9.33533 11.3015C9.51408 11.4765 9.78658 11.4578 9.94033 11.2603L17.7803 1.20027C17.8542 1.10465 17.8873 0.983679 17.8723 0.86377C17.8573 0.743861 17.7955 0.634753 17.7003 0.560266ZM12.5753 0.560266L11.9778 0.0952655C11.8826 0.0216963 11.7623 -0.0113049 11.6429 0.00344339C11.5235 0.0181917 11.4147 0.079496 11.3403 0.174015L4.64533 8.76402C4.61083 8.81011 4.56679 8.84821 4.51622 8.87572C4.46564 8.90323 4.40973 8.9195 4.35229 8.92342C4.29485 8.92734 4.23724 8.91881 4.1834 8.89842C4.12956 8.87802 4.08076 8.84625 4.04033 8.80527L1.30158 6.12652C1.21493 6.0427 1.0987 5.99647 0.97816 5.99787C0.857616 5.99928 0.742498 6.0482 0.657827 6.13402L0.129077 6.67527C0.0450318 6.76154 -0.00137487 6.87763 3.10374e-05 6.99807C0.00143694 7.11851 0.0505407 7.23347 0.136577 7.31777L4.20908 11.299C4.38783 11.474 4.66033 11.4553 4.81408 11.2578L12.6541 1.19777C12.7276 1.10258 12.7606 0.9822 12.7459 0.862809C12.7311 0.743418 12.6698 0.634682 12.5753 0.560266Z"
            fill="#4FC3F7"
        ></path>
    </svg>
);

export const IconPause = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M12 8v16H8V8h4m0-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm12 2v16h-4V8h4m0-2h-4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z"
        />
    </svg>
);

export const IconPlay = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="M7 28a1 1 0 0 1-1-1V5a1 1 0 0 1 1.482-.876l20 11a1 1 0 0 1 0 1.752l-20 11A1 1 0 0 1 7 28ZM8 6.69v18.62L24.925 16Z"
        />
    </svg>
);

export const IconSearch = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <path
            fill="currentColor"
            d="m29 27.586l-7.552-7.552a11.018 11.018 0 1 0-1.414 1.414L27.586 29ZM4 13a9 9 0 1 1 9 9a9.01 9.01 0 0 1-9-9Z"
        />
    </svg>
);

export const IconHamburger = ({ color = '#000', size = '20px' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
    >
        <rect x="0" y="0" width="32" height="32" fill="none" stroke="none" />
        <circle cx="16" cy="8" r="2" fill="currentColor" />
        <circle cx="16" cy="16" r="2" fill="currentColor" />
        <circle cx="16" cy="24" r="2" fill="currentColor" />
    </svg>
);

export const IconDefault = ({ color = '#000', size = '20px' }) => <svg />;
